/**
 * PoweredByFooter — a small "Powered by The Vyomra HOS" tag added to the
 * bottom of every print artifact (Rx, bill, discharge, lab report, payslip,
 * kiosk token). Deliberately tiny, muted and set to `break-inside:avoid` so
 * it never orphans onto a blank page.
 */
export default function PoweredByFooter({ align = "center", className = "" }) {
  const alignMap = { center: "text-center", left: "text-left", right: "text-right" };
  return (
    <div
      data-testid="powered-by-footer"
      className={`mt-4 pt-1 text-[8px] tracking-widest text-slate-400 uppercase ${alignMap[align] || "text-center"} ${className}`}
      style={{ pageBreakInside: "avoid", breakInside: "avoid", pageBreakBefore: "avoid", breakBefore: "avoid" }}
    >
      Powered by <span className="font-semibold text-slate-500">The&nbsp;Vyomra&nbsp;HOS</span>
    </div>
  );
}

/** Plain HTML string version — for `window.open` print snippets that don't
 * mount React (kiosk token, investigations print). Keep the markup tiny so it
 * fits any layout (A4, thermal 58 mm/80 mm) without wrapping. */
export const poweredByFooterHtml = () => `
<div style="margin-top:14px;padding-top:4px;text-align:center;font-size:8px;letter-spacing:0.14em;text-transform:uppercase;color:#94a3b8;page-break-inside:avoid;break-inside:avoid;">
  Powered by <span style="font-weight:600;color:#64748b;">The&nbsp;Vyomra&nbsp;HOS</span>
</div>`;
